import Device from 'constants/deviceSizes';
import { textInput } from 'constants/fonts';

export default {
  container: {
    display: 'flex'
  },
  content: {
    display: 'flex',
    justifyContent: 'center'
  },
  containerPopup: {
    minWidth: 400,
    width: '100%',
    minHeight: 50,
    height: '100%',
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
    padding: '0 15px',
    boxSizing: 'border-box',
    [Device.mobile]: {
      minWidth: 0
    }
  },
  containerElements: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginBottom: 10
  },
  textContainer: {
    display: 'flex',
    margin: '0 auto',
    alignItems: 'flex-end'
  },
  element: {
    display: 'flex',
    margin: '0 10px 0px'
  },
  downloadButton: {
    height: 20
  },
  billDetail: {
    paddingRight: 5
  },
  labelButton: {
    marginLeft: 6
  },
  textInputSize: {
    fontSize: textInput
  }
};
